export default "__VITE_ASSET__DvmXR6Pi__"